{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              24.185099489209847,
              65.64670301817839
            ],
            [
              20.997377833646624,
              69.0390906444714
            ],
            [
              12.017606347429961,
              63.25299753588982
            ],
            [
              12.766059194806388,
              61.093208719226254
            ],
            [
              11.65436051021544,
              58.930780643055016
            ],
            [
              11.02748371031987,
              58.945303303169624
            ],
            [
              11.774743616966646,
              56.462233646332834
            ],
            [
              12.565547428638894,
              56.10972783674052
            ],
            [
              12.921565552747865,
              55.575088888825945
            ],
            [
              12.7144929939993,
              54.91556962819263
            ],
            [
              15.796273888561359,
              54.758637369430176
            ],
            [
              19.60034774052687,
              57.49688375443074
            ],
            [
              19.40603216580712,
              60.65576147261095
            ],
            [
              19.778850865044006,
              62.691186006525754
            ],
            [
              24.185099489209847,
              65.64670301817839
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}